import { SysDataBaseApi } from "./SysDataBaseApi";
import { Methods } from '@newview/infrastructure';
/**
 * 工程结构数据Api
 */
export class RoadinfobusinessinstitutionApi extends SysDataBaseApi {
    public get ControllerName(): any {
        return 'Roadinfobusinessinstitution'
    }
}
